export const Entity = `
    entity {
        geoType
        fullUid
        name
        membertype
        websiteurl
        notes
        instruc
        datelastchanged
        description
        document
        layerid
        address
        city
        state
        zip
    }
`;
